import { ProgressSpinner } from "primereact/progressspinner"

import "./index.scss"

const DocumentoActionItem = ({
  Icon,
  loading,
  title,
  description,
  onDownload,
}: $TSMigrationFixMe) => {
  return (
    <div
      title={`Descargar ${title}`}
      onClick={loading ? null : onDownload}
      className='documentoActionItem'
    >
      <div className='documentoActionItem__icon'>{Icon && <Icon />}</div>
      <div className='documentoActionItem__title'>{title}</div>
      <div className='documentoActionItem__description'>{description}</div>
      {loading && (
        <div className='documentoActionItem__loading'>
          <ProgressSpinner
            style={{ width: "20px", height: "20px" }}
            // @ts-expect-error TS(2769): No overload matches this call.
            strokeWidth={3}
          />
        </div>
      )}
    </div>
  )
}

export default DocumentoActionItem
